import { useTranslation } from 'react-i18next'
import React from 'react'

import { useTab } from '../../../components/tabs/TabsContext'
import { useTriggerCallState } from './_load/TriggerCallLoader'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Text, { Label } from '../../../packages/kiti/components/presentation/Text'

const TriggerCallDetails = () => {
  const { t } = useTranslation()
  const { data } = useTriggerCallState()?.triggerCall
  const { result, payload, record, trigger, ...rest } = data
  const tab = useTab()
  let value = rest
  switch (tab?.value) {
    case 'result':
      value = result
      break
    case 'payload':
      value = payload
      break
    case 'record':
      value = record
      break
    case 'trigger':
      value = trigger
      break
  }

  return (
    <Panel bgColor="light1" noMargin scroll>
      <Text>
        <pre>
          <code>{JSON.stringify(value, null, 4)}</code>
        </pre>
      </Text>
    </Panel>
  )
}

export default TriggerCallDetails
